<script>
export default {
    props: {
        sessions: {
            default() {
                return []
            }
        },
        currentSession: {
            default() {
                return ''
            }
        }
    }
}
</script>

<template>
    <div class="session-wrapper">
        <div v-for="session in sessions" class="session-item"
            :class="{ 'selected': session.sessionId === currentSession }" @click="$emit('change', session.sessionId)"
            v-html="session.title"></div>
        <div class="session-item new-session" @click="$emit('new')">
            {{ $t('ai_tutor_new_session') }}
        </div>
    </div>
</template>

<style scoped>
.session-wrapper {
    display: flex;
    flex-direction: column-reverse;
    gap: 0.7rem;
    padding: 0.9rem;
}

.session-item {
    border-radius: 0.9rem;
    padding: 0.5rem 0.9rem;
    color: #0D30A0;
    border: 1px solid #0D30A0;
    cursor: pointer;
    font-size: 0.9rem;
}

.session-item:deep(>*) {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 0;
}

.session-item.selected {
    background-color: #0D30A0;
    color: #fff;
}

.new-session {
    border-style: dashed;
    border-color: #666;
    background-color: #f1f1f1;
    color: #666;
    position: sticky;
    top: 0;
}
</style>